import styled from 'styled-components';

export default styled.div`
  padding: 1rem 0;
  text-align: center;
  font-size: 0.9rem;

  & > .btn {
    margin-top: 1rem;
  }
`;
